import _has from 'lodash/has';
import _isNaN from 'lodash/isNaN';
import _parseInt from 'lodash/parseInt';
// Serialization
import { deserialize } from 'serializr';
import { operationSchema } from './schemas';
// Async model (from app: some functions are identical)
import mAsync from '../async';
// Fragments
import { operationFragment } from './fragments';
// Custom
import {
  ASYNC_OP_STATUS_PENDING, ASYNC_OP_STATUS_SUCCESS, ASYNC_OP_STATUS_ERROR, ASYNC_OP_STATUS_IGNORED,
} from '../../constants/App';
import { numberTo2DigitsString } from '../../utils/Tools';

/**
* Serialization
*/
const deserializeOperation = (data) => {
  if (!data) {
    return null;
  }
  return deserialize(operationSchema, data);
};

/**
* Utils
*/
// --- Operations --- //
const createOperation = (serverOperation, opts) => {
  // Basic checks
  if (!serverOperation || !opts || !opts.key) {
    return null;
  }
  // Check id
  const idObj = _parseInt(opts.id);
  if (!idObj || _isNaN(idObj)) {
    return null;
  }
  // Create operation based on server information
  return {
    ...serverOperation,
    targetKey: opts.key,
    [opts.key]: idObj,
  };
};

// --- Status --- //
const synchronisationStatusFromBool = (synchronized) => (synchronized ? ASYNC_OP_STATUS_SUCCESS : ASYNC_OP_STATUS_ERROR);

const synchronisationStatusLabel = (status, code) => (
  (status !== ASYNC_OP_STATUS_PENDING && status !== ASYNC_OP_STATUS_IGNORED) ? `asyncOperation.responseCode.${numberTo2DigitsString(code)}` : `syncStatus.${status}`
);

// Get error description for an operation which concerns only one device
const synchronizationOperationMonoDeviceErrorDesc = (operation) => {
  const operationDevice = operation.devices[0];
  if (_has(operationDevice, 'error.code')) {
    return `asyncOperation.responseCode.${numberTo2DigitsString(operationDevice.error.code)}`;
  }
  return null;
};

// From async model
const synchronizationStatusIcon = (status) => mAsync.statusIcon(status);

/**
* GraphQL
*/
const subOperationUpdated = `
  subscription OperationUpdated($input: OperationUpdatedInput!) {
    operationUpdated(input: $input) {
      ...operationFragment
    }
  }

  ${operationFragment}
`;

/**
* Model
*/
const synchronization = {
  // Name
  name: 'synchronization',

  // Serialization
  deserialize: deserializeOperation,

  // Utils
  createOperation,
  statusFromBool: synchronisationStatusFromBool,
  statusLabel: synchronisationStatusLabel,
  operationMonoDeviceErrorDesc: synchronizationOperationMonoDeviceErrorDesc,
  statusIcon: synchronizationStatusIcon,

  // GraphQL
  subOperationUpdated,
};

module.exports = synchronization;



// WEBPACK FOOTER //
// ./models/cpm/synchronization.js